import { getBooleanFromValue, isFunction, isObject, isSet } from '@/global/utils/utils'
import { api } from '@/global/services/api'

const TAB_KEY = 'fuelProbe2'
const CALIBRATION_VALUES_DATA_KEY = 'calibration_values_2'
export default {
  data () {
    return {
      fuelProbe2InputTypeExists: false,
      fuelProbe2CurrentValueLoading: false
    }
  },

  computed: {
    fuelProbe2Config () {
      return {
        title: this.$t('base/tracker.fuel_probe_2'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadFuelProbes),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/fuel-probe/2`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/fuel-probe/2`
          }
        },
        dataFetched: (event) => this.onFuelProbe2DataFetched(event, event?.data?.data),
        afterSave: (event, data) => this.onFuelProbe2DataFetched(event, data),
        afterCancel: (event) => this.onFuelProbe2DataFetched(event, event?.formDataForSend),
        modifyDataBeforeSend: (event) => this.onModifyFuelProbe2BeforeSend(event),
        hiddenFormKeys: [
          CALIBRATION_VALUES_DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.fuel_probe_2'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'fuel_probe_status_2',
                    label: this.$t('base/tracker.fuel_probe_status'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 1,
                        name: this.$t('base.active')
                      },
                      {
                        id: 0,
                        name: this.$t('base.inactive')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'input_type_2_id',
                    label: this.$t('base/tracker.probe_attribute_input_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'probe-attribute-input-types'
                    },
                    onChange: (event) => {
                      this.fuelProbe2InputTypeExists = getBooleanFromValue(event?.selectedItem)
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'declared_tank_capacity_2',
                    label: this.$t('base/tracker.declared_tank_capacity'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max_real_tank_capacity_2',
                    label: this.$t('base/tracker.max_real_tank_capacity'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'refuel_tolerance_2',
                    label: this.$t('base/tracker.refuel_tolerance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'fuel_leak_tolerance_2',
                    label: this.$t('base/tracker.fuel_leak_tolerance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'samples_size_2',
                    label: this.$t('base/tracker.fuel_leak_samples_size'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'calibration_unit_2',
                    label: this.$t('base/tracker.calibration_unit'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 0,
                        name: this.$t('base/tracker.percentage')
                      },
                      {
                        id: 1,
                        name: this.$t('base/tracker.liters')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max',
                    label: this.$t('base/tracker.max_liters'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    readonly: !this.fuelProbe2InputTypeExists,
                    visible: true
                  },
                  {
                    key: 'current_value',
                    label: this.$t('base/tracker.current_value'),
                    field_type: 'number',
                    appendIcon: this.fuelProbe2InputTypeExists ? 'mdi-sync' : '',
                    appendLoading: this.fuelProbe2CurrentValueLoading,
                    appendIconClick: (event) => this.onFuelProbe2GetCurrentValue(event),
                    creatable: false,
                    editable: false,
                    readonly: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            type: 'dynamic-columns',
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            title: this.$t('base/tracker.calibration_values'),
            key: CALIBRATION_VALUES_DATA_KEY,
            display_props: ['new_value', 'current_value'],
            headers: [this.$t('base/tracker.new_value'), this.$t('base/tracker.current_value')],
            fields: [
              {
                key: 'new_value',
                field_type: 'number',
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'current_value',
                field_type: 'number',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onModifyFuelProbe2BeforeSend (event) {
      const { copiedData } = event || {}
      if (copiedData?.[CALIBRATION_VALUES_DATA_KEY]?.length) {
        copiedData[CALIBRATION_VALUES_DATA_KEY] = copiedData[CALIBRATION_VALUES_DATA_KEY].reduce((acc, item) => {
          acc[item.new_value] = item.current_value
          return acc
        }, {})
        if (isSet(copiedData?.max)) {
          copiedData[CALIBRATION_VALUES_DATA_KEY].max = copiedData.max
        }
      }
      else {
        delete copiedData[CALIBRATION_VALUES_DATA_KEY]
      }
      return copiedData
    },

    onFuelProbe2DataFetched (event, data) {
      const { updateData, updateFormData } = event || {}
      const updateDataCallback = isFunction(updateData)
        ? updateData
        : (isFunction(updateFormData)
            ? updateFormData
            : null
          )
      if (isSet(data) && isObject(data) && isFunction(updateDataCallback)) {
        const calibrationValues = []
        if (isSet(data?.calibration_values) && isObject(data.calibration_values)) {
          Object.keys(data.calibration_values).forEach(key => {
            const calibrationValue = data.calibration_values?.[key]
            if (key === 'max') {
              updateDataCallback({
                max: calibrationValue
              })
            }
            else {
              calibrationValues.push({
                new_value: key,
                current_value: calibrationValue
              })
            }
          })
        }

        const inputType = data?.input_type?.id || data?.input_type
        updateDataCallback({
          [CALIBRATION_VALUES_DATA_KEY]: calibrationValues,
          fuel_probe_status_2: data?.is_active,
          input_type_2_id: inputType,
          declared_tank_capacity_2: data?.declared_tank_capacity,
          max_real_tank_capacity_2: data?.max_real_tank_capacity,
          refuel_tolerance_2: data?.refuel_tolerance,
          fuel_leak_tolerance_2: data?.fuel_leak_tolerance,
          samples_size_2: data?.samples_size,
          calibration_unit_2: [1, '1'].includes(data?.is_calibration_in_liters) ? 1 : 0
        })

        this.fuelProbe2InputTypeExists = getBooleanFromValue(inputType)
      }
    },

    async onFuelProbe2GetCurrentValue (event) {
      try {
        const { updateData } = event || {}
        if (!isFunction(updateData)) {
          return
        }

        this.fuelProbe2CurrentValueLoading = true
        const data = await api('base').get('current-fuel-probe-value', {
          trackerId: this.$route?.params?.id,
          probeNumber: 2
        })
        const { value } = data || {}
        if (!isSet(value)) {
          return
        }

        updateData({
          current_value: value
        })
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.fuelProbe2CurrentValueLoading = false
      }
    }
  }
}
